import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';

const METRIC_PLACEHOLDERS = [
  { label: 'Open tickets', value: '—' },
  { label: 'Team online', value: '—' },
  { label: 'Sites healthy', value: '—' },
  { label: 'Notifications active', value: '—' },
];

/**
 * Company admin high-level metrics (placeholder).
 */
export default function AdminMetrics({ workspace }) {
  return (
    <Paper variant="outlined" sx={{ p: 2.5, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <InsightsIcon color="primary" />
        <Typography variant="h6">Admin metrics</Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        High-level workspace pulse
        {workspace?.name ? ` for ${workspace.name}` : ''}.
      </Typography>
      <Grid container spacing={1.5}>
        {METRIC_PLACEHOLDERS.map((m) => (
          <Grid key={m.label} size={{ xs: 6, sm: 3 }}>
            <Box
              sx={{
                p: 1.5,
                borderRadius: 1,
                bgcolor: 'action.hover',
                textAlign: 'center',
              }}
            >
              <Typography variant="h5" fontWeight={700}>
                {m.value}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {m.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
